/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UtilsService } from '../../services';

@Component({
  selector: '[fullPageModal]',
  templateUrl: './full-page-modal.component.html',
  styleUrls: ['./full-page-modal.component.scss'],
})
export class FullPageModalComponent implements OnInit {
  @Output() back: EventEmitter<any> = new EventEmitter();
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Input() classes: string[];
  @Input() backText: string;
  @Input() closeText: string;

  constructor(private utilsService: UtilsService) {}

  ngOnInit() {
    this.utilsService.showPageModal();
  }

  ngOnDestroy() {
    this.utilsService.hidePageModal();
  }

  backAction($event) {
    $event.preventDefault();
    this.back.emit();
  }

  closeAction($event) {
    $event.preventDefault();
    this.close.emit();
  }
}
